var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticClass: "bg-white" },
        [
          _c("el-col", { attrs: { span: 16 } }, [
            _c("div", { staticClass: "pl-20 pt-10 pb-10 l-b fs-a1" }, [
              _vm._v("绑定小程序"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pl-30" },
              [
                _vm.siteInfo.wx_third_api_switch
                  ? _c(
                      "div",
                      { staticClass: "pt-20 mb-20 flex fs-c1" },
                      [
                        _c("span", [
                          _vm._v("请先将小程序授权给我们，才能给您发布代码，"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-link",
                          {
                            staticClass: "fs-c1",
                            attrs: {
                              href: _vm.baseURL + "Authorize/authorize",
                              target: "_blank",
                              type: "primary",
                            },
                          },
                          [_vm._v("点我进行授权")]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("，请勾选全部权限，否则授权无效噢！"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to:
                                "/tutorial/detail/" + _vm.config.wx_tutorial_id,
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "el-link",
                              {
                                staticClass: "fs-c1",
                                attrs: { target: "_blank", type: "danger" },
                              },
                              [_vm._v("查看资料获取教程")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-width": "200px",
                      "label-position": "left",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "小程序名称：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.app_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "app_name", $$v)
                            },
                            expression: "form.app_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "小程序标识(APPID)：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.app_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "app_id", $$v)
                            },
                            expression: "form.app_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "小程序APPSECRET：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.app_secret,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "app_secret", $$v)
                            },
                            expression: "form.app_secret",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "小程序原始ID：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.origin_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "origin_id", $$v)
                            },
                            expression: "form.origin_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "微信支付商户号(MCHID)：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.pay_mchid,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "pay_mchid", $$v)
                            },
                            expression: "form.pay_mchid",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "微信支付API秘钥(key)：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.pay_key,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "pay_key", $$v)
                            },
                            expression: "form.pay_key",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "微信支付APIV3秘钥：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.apiv3_key,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "apiv3_key", $$v)
                            },
                            expression: "form.apiv3_key",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "支付证书(apiclient_cert)：" } },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", rows: 6 },
                          model: {
                            value: _vm.form.payssl_cert,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "payssl_cert", $$v)
                            },
                            expression: "form.payssl_cert",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "支付证书密钥(apiclient_key)：" } },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", rows: 6 },
                          model: {
                            value: _vm.form.payssl_key,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "payssl_key", $$v)
                            },
                            expression: "form.payssl_key",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "支付API证书序列号：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.serial_no,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "serial_no", $$v)
                            },
                            expression: "form.serial_no",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "微信支付分id(service_id)：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.service_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "service_id", $$v)
                            },
                            expression: "form.service_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: _vm.clickSubmit,
                            },
                            on: { click: _vm.onSubmit },
                          },
                          [_vm._v("提交")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }